import { Component } from '@angular/core';
import { HeroSectionComponent } from "./components/hero-section/hero-section.component";
import { AboutSectionComponent } from "./components/about-section/about-section.component";
import { FinalJoinSectionComponent } from "./components/final-join-section/final-join-section.component";
import { InvestmentFlowService } from '../../core/services/Investment-flow/investment-flow.service';
import { HighlightSectionComponent } from "./components/highlight-section/highlight-section.component";
import { StatsSectionComponent } from './components/stats-section/stats-section.component';
import { ServiceSectionComponent } from "./components/service-section/service-section.component";
import { FinalStatsSectionComponent } from "./components/final-stats-section/final-stats-section.component";
import { BrandCtaSectionComponent } from "./components/brand-cta-section/brand-cta-section.component";
import { InvestmentProgComponent } from "./components/investment-prog/investment-prog.component";
@Component({
  selector: 'app-home',
  imports: [HeroSectionComponent, AboutSectionComponent, FinalJoinSectionComponent, HighlightSectionComponent, StatsSectionComponent, ServiceSectionComponent, FinalStatsSectionComponent, BrandCtaSectionComponent, InvestmentProgComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css',
})
export class HomeComponent {
constructor(public flow: InvestmentFlowService){}
}
